var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomSoftwareIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 185.894,
    height: 211.49,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M133.76 192.847l-83.3 18.209a18.612 18.612 0 0 1-22.158-14.208L.43 69.348a18.612 18.612 0 0 1 16.745-22.531l73.143-5.668a18.612 18.612 0 0 1 19.111 12.714l38.024 114.957a18.612 18.612 0 0 1-13.693 24.027z",
    fill: "#05436f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M152.159 172.851l-83.3 18.209a18.612 18.612 0 0 1-22.158-14.208l-27.872-127.5a18.612 18.612 0 0 1 16.745-22.531l73.143-5.668a18.612 18.612 0 0 1 19.111 12.714l38.024 114.957a18.612 18.612 0 0 1-13.693 24.027z",
    fill: "#0b72b9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M171.249 153.761l-83.3 16.2a18.612 18.612 0 0 1-22.158-14.208l-27.872-127.5A18.612 18.612 0 0 1 54.664 5.722L127.807.054a18.612 18.612 0 0 1 19.111 12.713l38.024 114.957c3.476 10.486-2.903 23.678-13.693 26.037z",
    fill: "#7fc4fd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomSoftwareIcon);
export default __webpack_public_path__ + "static/media/Custom Software Icon.c2d29ed8281316668126bbfe181eec57.svg";
export { ForwardRef as ReactComponent };